import { FormConfig } from '../../models/dynamic.model';
import { TableColumnsProp } from '../../models/tables.model';

export const selectedAndDefaultColumns = {
  defaultView: true,
  isSelected: true,
};

export function isGrOrPodStatusCode(
  code:
    | {
        statusCode?: string;
        statusCodeTypeName?: string;
        name?: string;
        codeAndDescription?: string;
      }
    | null
    | undefined
): boolean {
  if (!code) {
    return false;
  }
  const ibcCode =
    typeof code.statusCode === 'string' ? code.statusCode.trim().toUpperCase() : '';
  if (ibcCode === 'GR' || ibcCode === 'POD') {
    return true;
  }
  if (code.statusCodeTypeName === 'Delivery') {
    return true;
  }
  const displayName = code.name ?? code.codeAndDescription ?? '';
  const prefixMatch = displayName.trim().match(/^([A-Za-z0-9]+)\s*-/);
  if (prefixMatch) {
    const prefix = prefixMatch[1].toUpperCase();
    return prefix === 'GR' || prefix === 'POD';
  }
  return false;
}

export const statusCodeTableGridColumns: TableColumnsProp[] = [
  {
    key: 'dateTimeAndTimezone',
    label: 'Date, Time, Time Zone',
    ...selectedAndDefaultColumns,
  },
  {
    ...selectedAndDefaultColumns,
    key: 'userName',
    label: 'User',
  },
  {
    label: 'Code & Description ',
    ...selectedAndDefaultColumns,
    key: 'codeAndDescription',
  },
  {
    label: 'Attachment',
    key: 'attachments',
    ...selectedAndDefaultColumns,
  },
  {
    ...selectedAndDefaultColumns,
    label: 'Additional Details ',
    key: 'additionalDetails',
  },
];

/** FR-BPM-UI-001: Manifest Information page only. */
export const manifestStatusCodeTableGridColumns: TableColumnsProp[] = [
  ...statusCodeTableGridColumns,
  {
    ...selectedAndDefaultColumns,
    label: 'Shipments Linked',
    key: 'shipmentsLinked',
  },
];

export const statusCodeTableFormConfigFields: FormConfig = {
  fields: [
    {
      label: '',
      id: 'dateTimeAndTimezone',
      type: 'input',
    },
    {
      id: 'codeAndDescription',
      label: '',
      type: 'input',
      required: true,
      requiredError: 'Status Code is required',
    },
    {
      id: 'userName',
      label: '',
      type: 'extra',
    },
    {
      id: 'driverName',
      type: 'extra',
      label: '',
    },
    {
      type: 'extra',
      id: 'carrierName',
      label: '',
    },
    {
      id: 'description',
      label: '',
      type: 'extra',
    },
    {
      label: '',
      id: 'typeCodeId',
      type: 'extra',
    },
    {
      id: 'id',
      label: '',
      type: 'extra',
    },
    {
      id: 'tempId',
      type: 'extra',
      label: '',
    },
    {
      id: 'statusCodeTypeName',
       type: 'extra',
      label: '',
    },
    {
      label: '',
      id: 'statusCodeAttachments',
      type: 'extra',
    },
    // Manifest POD input-row state (SPEC-BPM-001) — stripped before any API call.
    {
      id: 'podPreview',
      type: 'extra',
      label: '',
    },
    {
      id: 'selectedHawbIds',
      type: 'extra',
      label: '',
    },
    {
      id: 'podDateTime',
      type: 'extra',
      label: '',
    },
  ],
};

export const statusCodesAttachmentFormFieldConfig: FormConfig = {
  fields: [
    {
      id: 'attachmentId',
      label: 'Attachment',
      type: 'file',
      required:true,
      requiredError: 'Attachment is required',
    },
    {
      type: 'input',
      label: 'Description',
      isCheckForMaxValue: true,
      maxValue: 500,
      id: 'description',
    },
  ],
};

export const statusCodePodDetailsConfig: FormConfig = {
  fields: [
    {
      id: 'carrierName',
      label: 'Carrier Name / POD Name',
      type: 'input',
      required: true,
      maxValue: 50,
      isCheckForMaxValue: true,
    },
    {
      label: 'Driver Name',
      id: 'driverName',
      required: false,
      type: 'input',
      isCheckForMaxValue: true,
      maxValue: 50,
    },
  ],
};
